import { render, staticRenderFns } from "./consultar-fornecedor.vue?vue&type=template&id=68f86927"
import script from "./consultar-fornecedor.vue?vue&type=script&lang=js"
export * from "./consultar-fornecedor.vue?vue&type=script&lang=js"
import style0 from "./consultar-fornecedor.vue?vue&type=style&index=0&id=68f86927&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports